import type { HTTPParams } from "@shared/types/HTTP";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export default class ProductDetailPageRequestService {
  cache: Record<string, unknown>;

  constructor() {
    this.cache = {};
  }

  async makeRequest(httpPromiseParams: HTTPParams) {
    let cacheKey = `url--${httpPromiseParams.url}`;

    if (httpPromiseParams.data) {
      cacheKey += this.stringifyParams(httpPromiseParams.data);
    }

    if (Object.keys(this.cache).includes(cacheKey)) {
      return this.cache[cacheKey];
    }

    const result = await HttpPromise(httpPromiseParams);

    if (httpPromiseParams.method === "GET") {
      this.cache[cacheKey] = result;
    }

    return result;
  }

  stringifyParams(dataParams) {
    const sortedKeys = Object.keys(dataParams).sort();
    return sortedKeys
      .map(key => {
        const value = JSON.stringify(dataParams[key]);
        return `${key}--${value}`;
      })
      .join("__");
  }
}
